import globalState from "../global-state";

import { fetchWrapper } from "../../utils/fetchWrapper";
import { router } from "../../App"

export interface IPropostaState {
    lojaUrl?: string
    logo?: string
    simulacaoesProposta?: IProposta[]
}

export interface IProposta {
    idSimulacao?:string
    dtEnvio?: string
    numeroProposta?: number
    status?: string
    mensagemDownloadProposta?: string
    enviadaParaConcentrador?: boolean
}

export interface IReenviaSigas {
    sucesso?: boolean
    mensagem?: string
}

export const downloadProposta = async (index: number, idSimulacao: string) => {
    globalState.isLoading.set(true);

    try{
        await fetchWrapper(`/api/proposta/downloadProposta/${idSimulacao}`, 
        null, 
        { isDownloadFile: true })

        globalState.faseProposta
            .simulacaoesProposta[index]
            .mensagemDownloadProposta
            .set("");
    }catch{
        globalState.faseProposta
            .simulacaoesProposta[index]
            .mensagemDownloadProposta
            .set("Não foi possível realizar o download da proposta. Tente novamente em alguns instantes.");  
    }

    globalState.isLoading.set(false);
}

const getReenviarPropostaSigasFetch = () =>
    fetchWrapper<IReenviaSigas>("/api/proposta/ReenviarPropostaSigas");

export const reenviarPropostaSigas = async (index: number) => {
    globalState.isLoading.set(true);

    const response = await getReenviarPropostaSigasFetch();

    globalState.faseProposta.simulacaoesProposta[index].enviadaParaConcentrador.set(response.sucesso)

    globalState.isLoading.set(false);
}

const getFasePropostaFetch = () =>
    fetchWrapper<IPropostaState>("/api/proposta");

export const gotoFaseProposta = async () => {
    globalState.isLoading.set(true);

    const response = await getFasePropostaFetch();
    globalState.faseProposta.set(response);
    
    await router.navigate("/proposta", { replace: true });
    
    globalState.isLoading.set(false);
}